import { API } from "@/lib/api";
export const KEY_LABELS = {"barite_sacks": ["Barite", "sk"], "sacks_of_cement": ["Cement", "sk"], "strokes": ["Strokes", "stk"], "a1": ["Azimuth 1", "°"], "a2": ["Azimuth 2", "°"], "additive_gal_per_sack": ["Additive volume", "gal/sk"], "additive_lb_per_sack": ["Additive weight", "lb/sk"], "ai": ["Ai", "in²"], "ann_cap": ["Annular capacity", "bbl/ft"], "annulus_length": ["Annulus length", "ft"], "ao": ["Ao", "in²"], "area": ["Steel A", "in²"], "as_": ["As (steel)", "in²"], "cement_sg": ["Cement SG", ""], "cl": ["Course Length", "ft"], "current_mw": ["Current MW", "ppg"], "delta_pi_avg": ["ΔPi avg", "psi"], "delta_pi": ["ΔPi", "psi"], "delta_po_avg": ["ΔPo avg", "psi"], "delta_po": ["ΔPo", "psi"], "dilution_w": ["Dilution wt", "ppg"], "float_collar_depth": ["Float collar depth", "ft"], "force": ["Force", "lbf"], "formation_pressure_ppg": ["Formation pressure", "ppg equiv."], "frac_grad_ppg": ["Fracture gradient at shoe", "ppg"], "i1": ["Inclination 1", "°"], "i2": ["Inclination 2", "°"], "id": ["ID", "in"], "jar_setting_lbf": ["Jar setting", "lbf"], "kick_fluid": ["Kick fluid ρ", "ppg"], "kick_intensity": ["Kick intensity", "ppg"], "length_above_jar_ft": ["Length above jar", "ft"], "length_ft": ["Stuck depth", "ft"], "length": ["Length", "ft"], "lot_ppg": ["LOT", "ppg"], "lot_surface": ["LOT surface", "psi"], "mw": ["Mud weight", "ppg"], "od_in": ["Casing OD", "in"], "od": ["OD", "in"], "pipe_cap": ["Pipe capacity", "bbl/ft"], "pipe_weight_ppf": ["Pipe weight", "lb/ft"], "pipe_wt": ["Pipe weight", "lb/ft"], "pull_diff": ["Pull diff", "lbf"], "pull_factor": ["Pull factor", ""], "pump_output": ["Pump output", "bbl/stk"], "safety": ["Safety", ""], "setting_depth": ["Casing setting depth", "ft TVD"], "sf_burst": ["Burst SF", ""], "sf_collapse": ["Collapse SF", ""], "sf_tension": ["Tension SF", ""], "shoe_frac": ["Shoe frac gradient", "ppg"], "shoe_tvd": ["Shoe TVD", "ft"], "shoetrack_cap": ["Shoetrack pipe cap", "bbl/ft"], "shoetrack_length": ["Shoetrack length", "ft"], "sidpp": ["SIDPP", "psi"], "slurry_bbl": ["Slurry volume", "bbl"], "stretch": ["Stretch", "in"], "tvd": ["TVD", "ft"], "v1": ["Volume", "bbl"], "w1": ["Current MW", "ppg"], "w2": ["Target MW", "ppg"], "wall_t": ["Wall", "in"], "water_gps_per_sack": ["Mix water", "gal/sk"], "weight_ppf": ["Est. pipe weight (guess)", "lb/ft"], "well_depth": ["Well depth", "ft"], "well_tvd": ["Well TVD", "ft"], "wt_ppf": ["Weight", "lb/ft"], "yield_ft3_per_sack": ["Slurry yield", "ft³/sk"], "yield_strength": ["Yield", "psi"], "selected_od": ["Casing OD", "in"], "selected_weight": ["Weight", "lb/ft"], "selected_grade": ["Grade", ""], "burst_rating": ["Burst rating", "psi"], "collapse_rating": ["Collapse rating", "psi"], "joint_strength": ["Joint strength", "lbf"], "verdict": ["Verdict", ""]};


const UNIT_SUFFIX = [
  ["deg_per_100ft", "°/100ft"], ["ft3_per_sack", "ft³/sk"], ["ft_lb", "ft·lb"], ["ftlb", "ft·lb"],
  ["psi", "psi"], ["bbl", "bbl"], ["lbf", "lbf"], ["ppg", "ppg"], ["ft3", "ft³"], ["gal", "gal"],
  ["fps", "ft/s"], ["deg", "°"], ["ft", "ft"], ["in2", "in²"], ["in", "in"], ["lb", "lb"], ["m", "m"],
];
const SKIP = new Set(["unit", "error", "warning", "warnings", "calculator"]);

export function formatKey(key) {
  if (KEY_LABELS[key]) return { label: KEY_LABELS[key][0], unit: KEY_LABELS[key][1] };
  let label = key;
  let unit = "";
  for (const [suf, u] of UNIT_SUFFIX) {
    if (key.endsWith(`_${suf}`)) {
      label = key.slice(0, -(suf.length + 1));
      unit = u;
      break;
    }
  }
  const words = label.split("_").map((w) =>
    ["icp", "fcp", "kmw", "maasp", "tvd", "md", "mw", "sidpp", "sicp", "scr", "id", "od", "dls", "lot"].includes(w)
      ? w.toUpperCase()
      : w.charAt(0).toUpperCase() + w.slice(1)
  );
  return { label: words.join(" "), unit };
}

export function scalarEntries(obj = {}) {
  return Object.entries(obj)
    .filter(([k, v]) => !SKIP.has(k) && v !== null && v !== "" && ["number", "string"].includes(typeof v))
    .map(([k, v]) => ({ key: k, ...formatKey(k), value: typeof v === "number" ? v.toLocaleString() : v }));
}

export const shareUrl = (id) => `${API}/s/${id}`;

export function summaryText(share) {
  const lines = scalarEntries(share.outputs).slice(0, 6).map((e) => `• ${e.label}: ${e.value}${e.unit ? ` ${e.unit}` : ""}`);
  return `RIGCALC · ${share.title}\n${lines.join("\n")}\n\nFull result: ${shareUrl(share.id)}`;
}

const loadImg = (src) =>
  new Promise((res) => {
    const img = new Image();
    img.onload = () => res(img);
    img.onerror = () => res(null);
    img.src = src;
  });

export async function renderCard(share) {
  const outs = scalarEntries(share.outputs).slice(0, 6);
  const ins = scalarEntries(share.inputs).slice(0, 6);
  const W = 1080;
  const H = 360 + outs.length * 92 + (ins.length ? 90 + Math.ceil(ins.length / 2) * 56 : 0) + 140;
  const c = document.createElement("canvas");
  c.width = W;
  c.height = H;
  const g = c.getContext("2d");
  g.fillStyle = "#0b0e13";
  g.fillRect(0, 0, W, H);
  g.fillStyle = "#f59e0b";
  g.fillRect(0, 0, W, 10);

  const logo = await loadImg("/icon-192.png");
  if (logo) g.drawImage(logo, 60, 50, 96, 96);
  g.fillStyle = "#f8fafc";
  g.font = "bold 44px 'Chivo', 'Arial Black', sans-serif";
  g.fillText("RIGCALC", 176, 108);
  g.fillStyle = "#94a3b8";
  g.font = "22px 'JetBrains Mono', monospace";
  g.fillText((share.category || "").toUpperCase(), 176, 140);

  g.fillStyle = "#f8fafc";
  g.font = "bold 52px 'Chivo', sans-serif";
  g.fillText(share.title.slice(0, 30), 60, 250);

  let y = 320;
  g.strokeStyle = "#334155";
  g.lineWidth = 2;
  outs.forEach((e, i) => {
    g.fillStyle = "#94a3b8";
    g.font = "26px 'JetBrains Mono', monospace";
    g.fillText(e.label.toUpperCase(), 60, y + 52);
    g.fillStyle = i === 0 ? "#fbbf24" : "#f8fafc";
    g.font = `bold ${i === 0 ? 50 : 40}px 'JetBrains Mono', monospace`;
    const txt = `${e.value}${e.unit ? ` ${e.unit}` : ""}`;
    g.textAlign = "right";
    g.fillText(txt, W - 60, y + 56);
    g.textAlign = "left";
    g.beginPath();
    g.moveTo(60, y + 84);
    g.lineTo(W - 60, y + 84);
    g.stroke();
    y += 92;
  });

  if (ins.length) {
    y += 50;
    g.fillStyle = "#f59e0b";
    g.font = "bold 22px 'JetBrains Mono', monospace";
    g.fillText("INPUTS", 60, y);
    y += 20;
    ins.forEach((e, i) => {
      const x = i % 2 === 0 ? 60 : W / 2 + 10;
      const yy = y + Math.floor(i / 2) * 56 + 40;
      g.fillStyle = "#64748b";
      g.font = "22px 'JetBrains Mono', monospace";
      g.fillText(`${e.label}: `, x, yy);
      const w = g.measureText(`${e.label}: `).width;
      g.fillStyle = "#cbd5e1";
      g.fillText(`${e.value}${e.unit ? ` ${e.unit}` : ""}`, x + w, yy);
    });
    y += Math.ceil(ins.length / 2) * 56 + 20;
  }

  g.fillStyle = "#11151c";
  g.fillRect(0, H - 100, W, 100);
  g.fillStyle = "#f59e0b";
  g.font = "bold 26px 'JetBrains Mono', monospace";
  g.fillText("rigcalc.pro", 60, H - 42);
  g.fillStyle = "#64748b";
  g.font = "20px 'JetBrains Mono', monospace";
  g.textAlign = "right";
  g.fillText("Verify with your company procedures", W - 60, H - 42);
  g.textAlign = "left";

  return new Promise((res) => c.toBlob(res, "image/png"));
}
